







































import Vue from "vue";
import { mapActions } from "vuex";
import { get } from "../../api";
import DesignerSearch from "../DesignerSearch.vue";
export default Vue.extend({
  components: {
    DesignerSearch
  },
  data(): { [key: string]: any } {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  inject: ["modalDoneAction"],
  computed: {
    saveDisabled() {
      return this.data.designer.display_name === "" ? true : false;
    }
  },
  methods: {
    handleDesignerSelect(value: { name: any; display_name: string }) {
      this.data.designer = value;
    }
  }
});
